var map = {
	"./bike-svg.svg": 2252,
	"./cake-svg.svg": 9809,
	"./calendar-svg.svg": 1585,
	"./chart-svg.svg": 3845,
	"./globe-svg.svg": 2381,
	"./heart-svg.svg": 6262,
	"./money-svg.svg": 7597,
	"./trophy-svg.svg": 8144
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6481;